import { render, staticRenderFns } from "./PaginationPerPageFront.vue?vue&type=template&id=7022e8ae"
import script from "./PaginationPerPageFront.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationPerPageFront.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports